import laundriesService from "api/laundriesService";
import { useMutation } from "react-query";

const useCreateUpdateLaundryMutation = () => {
  return useMutation(async (data: any) => {
    try {
      const res = await laundriesService.createOrUpdateLaundry(data)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useCreateUpdateLaundryMutation